(function() { window.GUID_93f002dd_08bd_4f44_95e7_210867daf328 = { getGuid: function() { return "93f002dd-08bd-4f44-95e7-210867daf328"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-resultsagainst",
                        callback: (accordion, e) => {
                            const $tabmenu = accordion.$Container.find(".tabmenu.control-cs:not(.results-against-tabmenu)");
                            accordion.SetContentSticky($tabmenu);
                            if (ResultsAgainstSection.IsEmpty(accordion))
                                return;
                            //   ResultsAgainstSection.SetContentV1(accordion);
                            ResultsAgainstSection.SetContentV2(accordion);
                            accordion.$Control.offon(`click.${accordion.UniqueInstanceId}`, ".tabmenu.control-cs .tab-menu-item", (e) => {
                                const $item = $(e.currentTarget);
                                const timePeriod = $item.attr("id");
                                const isHighlighted = $item.hasClass("is-highlighted");
                                if (!isHighlighted) {
                                    $item.addClass("is-highlighted");
                                    $item.siblings().removeClass("is-highlighted");
                                    switch (timePeriod) {
                                        case "all":
                                            accordion.$Content
                                                .find(".results-against__body .all-time")
                                                .css({ display: "" });
                                            accordion.$Content
                                                .find(".results-against__body .recent")
                                                .css({ display: "none" });
                                            break;
                                        case "last-year":
                                            accordion.$Content
                                                .find(".results-against__body .recent")
                                                .css({ display: "" });
                                            accordion.$Content
                                                .find(".results-against__body .all-time")
                                                .css({ display: "none" });
                                            break;
                                        default:
                                    }
                                }
                            });
                        },
                    });
                    let ResultsAgainstSection;
                    (function (ResultsAgainstSection) {
                        function IsEmpty(accordion) {
                            var _a;
                            const $emptyStateElement = accordion.$Content.find(`#ResultsAgainstSectionViewModelNoData-${accordion.ContentId}`);
                            if ($emptyStateElement.length) {
                                const $gameTypeNameInput = accordion.$Content.find(`#ResultsAgainstSectionViewModelGameTypeName-${accordion.ContentId}`);
                                const gameTypeName = (_a = $gameTypeNameInput.val()) !== null && _a !== void 0 ? _a : "";
                                if (gameTypeName.trim() === "") {
                                    $emptyStateElement.text(JSRess.These2OpponentsHaveNeverPlayedAgainstEachOther);
                                }
                                else {
                                    $emptyStateElement.html(CS.Helper.formatString(JSRess.These2OpponentsHaveNeverPlayedAgainstEachOtherInX, gameTypeName));
                                }
                                return true;
                            }
                            return false;
                        }
                        ResultsAgainstSection.IsEmpty = IsEmpty;
                        function SetContentV1(accordion) {
                            const $statCanvas = accordion.$Content.find(".stat-container canvas");
                            const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                            if ($statCanvas.length) {
                                $statCanvas.each((index, canvas) => {
                                    const $canvas = $(canvas);
                                    const canvasId = $canvas.attr("id");
                                    const existingChart = Chart.getChart(canvasId);
                                    if (existingChart)
                                        existingChart.destroy();
                                    const $statContainer = $(canvas).closest(".stat-container");
                                    const _chartValueA = $statContainer.attr("data-chart-value-a");
                                    const _chartValueB = $statContainer.attr("data-chart-value-b");
                                    if (!_chartValueA || !_chartValueB)
                                        return;
                                    const chartValueA = Number(_chartValueA.replace(",", "."));
                                    const chartValueB = Number(_chartValueB.replace(",", "."));
                                    let total = chartValueA + chartValueB;
                                    const chart = new Chart(canvas, {
                                        type: "bar",
                                        data: {
                                            labels: [""],
                                            datasets: [
                                                {
                                                    label: "A",
                                                    data: [
                                                        {
                                                            x: chartValueA,
                                                            y: 0,
                                                        },
                                                    ],
                                                    backgroundColor: colors[0],
                                                    borderColor: "rgba(255,255,255,0.1)",
                                                },
                                                {
                                                    label: "B",
                                                    data: [
                                                        {
                                                            x: chartValueB,
                                                            y: 0,
                                                        },
                                                    ],
                                                    backgroundColor: colors[1],
                                                    borderColor: "rgba(255,255,255,0.1)",
                                                },
                                            ],
                                        },
                                        options: {
                                            responsive: true,
                                            aspectRatio: CS.CommonData.Current.IsMobileDevice ? 20 : 30,
                                            indexAxis: "y",
                                            borderColor: "rgba(255,255,255,0.1)",
                                            //animation: false,
                                            elements: {
                                                bar: {
                                                    borderSkipped: false,
                                                    borderWidth: 1,
                                                },
                                            },
                                            plugins: {
                                                legend: false,
                                                title: false,
                                                tooltip: false,
                                                datalabels: {
                                                    color: "white",
                                                    textShadowColor: "black",
                                                    textShadowBlur: 5,
                                                    formatter: function (value, context) {
                                                        const { x, y, displayValue } = value;
                                                        return `${displayValue}`;
                                                    },
                                                    font: {
                                                        size: 10,
                                                    },
                                                },
                                            },
                                            scales: {
                                                xAxis: {
                                                    stacked: true,
                                                    min: 0,
                                                    max: total,
                                                    //beginAtZero: true,
                                                    display: false,
                                                    grid: {
                                                        color: function (context) {
                                                            const { tick, index } = context;
                                                            if (tick.value === 0)
                                                                return "rgba(255,255,255,1)";
                                                            return "rgba(255,255,255,0.15)";
                                                        },
                                                        borderColor: "rgba(255, 255, 255, 0.15)",
                                                        drawTicks: true,
                                                    },
                                                    ticks: {
                                                        callback: function (value, index, values) {
                                                            if (value === 0)
                                                                return "100%";
                                                            if (index === 0 || index === values.length - 1)
                                                                return "0%";
                                                            if (value < 0)
                                                                return `${100 - value * -1}%`;
                                                            return `${100 - value}%`;
                                                        },
                                                    },
                                                },
                                                yAxis: {
                                                    display: false,
                                                    stacked: true,
                                                },
                                            },
                                        },
                                    });
                                });
                            }
                        }
                        ResultsAgainstSection.SetContentV1 = SetContentV1;
                        function SetContentV2(accordion) {
                            const $statCanvas = accordion.$Content.find(".stat-container canvas");
                            const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                            const width = 1200;
                            const marginTop = 0;
                            const marginRight = 0;
                            const marginBottom = 0;
                            const marginLeft = 0;
                            if ($statCanvas.length) {
                                $statCanvas.each((index, canvas) => {
                                    const $canvas = $(canvas);
                                    const $chartContainer = $canvas.closest(".canvas-container");
                                    const $statContainer = $canvas.closest(".stat-container");
                                    let chartContainerId = $chartContainer.attr("id");
                                    if (!chartContainerId) {
                                        chartContainerId = CS.Helper.generateRandomId();
                                        $chartContainer.attr("id", chartContainerId);
                                    }
                                    $canvas.css({ display: "none" });
                                    $chartContainer.addClass("stat-container__chart");
                                    const _valueA = $statContainer.attr("data-chart-value-a");
                                    const _valueB = $statContainer.attr("data-chart-value-b");
                                    if (!_valueA || !_valueB)
                                        return;
                                    const valueA = Number(_valueA.replace(",", "."));
                                    const valueB = Number(_valueB.replace(",", "."));
                                    const datapoints = [
                                        {
                                            stackId: "0",
                                            seriesId: "A",
                                            value: valueA,
                                            isStacked: false,
                                        },
                                        {
                                            stackId: "0",
                                            seriesId: "B",
                                            value: valueB,
                                            isStacked: true,
                                        },
                                    ];
                                    setTimeout(() => {
                                        const comparedValueBarChart = new CS.Controls.ComparedValueBarChart({
                                            colors: colors,
                                            containerElementId: chartContainerId,
                                            datapoints: datapoints,
                                        });
                                        comparedValueBarChart
                                            .init()
                                            .then(() => {
                                            CS.Helper.log("ComparedResults", "ComparedValueBarChart.init() done");
                                        })
                                            .catch((error) => {
                                            console.error("ComparedValueBarChart.init() error", error);
                                        });
                                    }, index * 10);
                                });
                            }
                        }
                        ResultsAgainstSection.SetContentV2 = SetContentV2;
                    })(ResultsAgainstSection = WallSections.ResultsAgainstSection || (WallSections.ResultsAgainstSection = {}));
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=results-against.js.map
